let audio,
    gameFrame,
    isFullscreen = false,
    displayTimer = null,
    selectedItemIndex = null,
    newItemIndex = -1,
    displayTime = 10;

class WhatMissingGame {
    constructor() {
        this.displayPhase = document.querySelector('[data-phase="display"]');
        this.selectionPhase = document.querySelector('[data-phase="selection"]');
        this.resultPhase = document.querySelector('[data-phase="result"]');
        this.timerElement = document.querySelector('[data-timer]');
        this.itemsGrid = this.selectionPhase ? this.selectionPhase.querySelector('.game__missing-items-grid') : null;

        // Pobierz dane z window
        if (window.whatMissingData) {
            displayTime = window.whatMissingData.displayTime;
            newItemIndex = window.whatMissingData.newItemIndex;
        }

        this.init();
    }

    init() {
        // Rozpocznij timer wyświetlania pierwszego zestawu
        this.startDisplayPhase();

        // Dodaj event listeners dla przedmiotów
        if (this.itemsGrid) {
            const itemButtons = this.itemsGrid.querySelectorAll('.game__missing-item--selectable');
            itemButtons.forEach(button => {
                button.addEventListener('click', () => this.selectItem(button));
            });
        }
    }

    startDisplayPhase() {
        let timeLeft = displayTime;

        // Odtwórz dźwięk startu
        if (audio && audio.start) {
            audio.start.play();
            stopAudioAfterDelay(audio.start, 2000);
        }

        displayTimer = setInterval(() => {
            timeLeft--;

            if (this.timerElement) {
                this.timerElement.textContent = timeLeft;

                // Animacja ostatnich 3 sekund
                if (timeLeft <= 3) {
                    this.timerElement.classList.add('timer-warning');
                    if (audio && audio.drag) {
                        audio.drag.play();
                    }
                }
            }

            if (timeLeft <= 0) {
                clearInterval(displayTimer);
                this.switchToSelectionPhase();
            }
        }, 1000);
    }

    switchToSelectionPhase() {
        // Ukryj fazę wyświetlania
        if (this.displayPhase) {
            this.displayPhase.classList.add('hidden');
        }

        // Pokaż fazę wyboru
        if (this.selectionPhase) {
            this.selectionPhase.classList.remove('hidden');
        }

        // Dźwięk przejścia
        if (audio && audio.drag) {
            audio.drag.play();
            stopAudioAfterDelay(audio.drag, 2000);
        }
    }

    selectItem(button) {
        const itemIndex = parseInt(button.dataset.itemIndex);
        const isNew = button.dataset.isNew === 'true';

        selectedItemIndex = itemIndex;

        // Wyłącz wszystkie przyciski
        const allButtons = this.itemsGrid.querySelectorAll('.game__missing-item--selectable');
        allButtons.forEach(btn => {
            btn.disabled = true;
            btn.classList.remove('hover-effect');
        });

        // Zaznacz wybrany przedmiot
        button.classList.add('selected');

        // Sprawdź odpowiedź
        if (isNew) {
            // Poprawna odpowiedź
            button.classList.add('correct');
            if (audio && audio.valid) {
                audio.valid.play();
                stopAudioAfterDelay(audio.valid, 2000);
            }
            gameFrame.style.borderColor = 'green';
        } else {
            // Niepoprawna odpowiedź
            button.classList.add('incorrect');
            if (audio && audio.wrong) {
                audio.wrong.play();
                stopAudioAfterDelay(audio.wrong, 2000);
            }
            gameFrame.style.borderColor = 'red';

            // Pokaż poprawną odpowiedź
            allButtons.forEach(btn => {
                if (btn.dataset.isNew === 'true') {
                    btn.classList.add('correct');
                }
            });
        }

        // Po 2.5 sekundach przejdź do wyniku
        setTimeout(() => {
            gameFrame.style.borderColor = 'black';
            this.showResult(isNew);
        }, 2500);
    }

    showResult(wasCorrect) {
        // Ukryj fazę wyboru
        if (this.selectionPhase) {
            this.selectionPhase.classList.add('hidden');
        }

        // Pokaż fazę wyniku
        if (this.resultPhase) {
            this.resultPhase.classList.remove('hidden');
        }

        // Ustaw treść wyniku
        const resultIcon = this.resultPhase.querySelector('[data-result-icon]');
        const resultTitle = this.resultPhase.querySelector('[data-result-title]');
        const resultMessage = this.resultPhase.querySelector('[data-result-message]');

        if (wasCorrect) {
            if (resultIcon) {
                resultIcon.innerHTML = '<i class="fa fa-check-circle"></i>';
                resultIcon.className = 'result-icon success';
            }
            if (resultTitle) {
                resultTitle.textContent = 'Brawo! Poprawna odpowiedź!';
                resultTitle.className = 'result-title success';
            }
            if (resultMessage) {
                resultMessage.textContent = 'Świetnie zapamiętałeś! Wybrałeś przedmiot, którego NIE było w pierwszym zestawie.';
            }

            // Dźwięk sukcesu
            if (audio && audio.success) {
                audio.success.play();
                stopAudioAfterDelay(audio.success, 3000);
            }
        } else {
            if (resultIcon) {
                resultIcon.innerHTML = '<i class="fa fa-times-circle"></i>';
                resultIcon.className = 'result-icon error';
            }
            if (resultTitle) {
                resultTitle.textContent = 'Niestety, to nie jest poprawna odpowiedź';
                resultTitle.className = 'result-title error';
            }
            if (resultMessage) {
                resultMessage.textContent = 'Ten przedmiot był w pierwszym zestawie. Spróbuj ponownie i zwróć uwagę na szczegóły.';
            }

            // Dźwięk błędu
            if (audio && audio.wrong) {
                audio.wrong.play();
                stopAudioAfterDelay(audio.wrong, 3000);
            }
        }
    }

    restart() {
        // Reset zmiennych
        selectedItemIndex = null;

        // Usuń klasy z przedmiotów
        if (this.itemsGrid) {
            const itemButtons = this.itemsGrid.querySelectorAll('.game__missing-item--selectable');
            itemButtons.forEach(button => {
                button.classList.remove('selected', 'correct', 'incorrect', 'hover-effect');
                button.disabled = false;
            });
        }

        // Reset faz
        if (this.displayPhase) {
            this.displayPhase.classList.remove('hidden');
        }
        if (this.selectionPhase) {
            this.selectionPhase.classList.add('hidden');
        }
        if (this.resultPhase) {
            this.resultPhase.classList.add('hidden');
        }

        // Reset timera
        if (this.timerElement) {
            this.timerElement.textContent = displayTime;
            this.timerElement.classList.remove('timer-warning');
        }

        // Reset ramki
        gameFrame.style.borderColor = 'black';

        // Rozpocznij od nowa
        this.startDisplayPhase();
    }
}

// Helper function
function stopAudioAfterDelay(audioElement, delay) {
    setTimeout(() => {
        if (audioElement) {
            audioElement.pause();
            audioElement.currentTime = 0;
        }
    }, delay);
}

// Initialize game function
function initGame() {
    gameFrame = document.querySelector('.game__frame--what-missing');

    if (!gameFrame) {
        return;
    }

    // Initialize audio
    audio = {
        start: document.getElementById('sound-start'),
        valid: document.getElementById('sound-valid'),
        wrong: document.getElementById('sound-wrong'),
        success: document.getElementById('sound-success'),
        drag: document.getElementById('sound-drag')
    };

    // Initialize game
    const game = new WhatMissingGame();

    // Fullscreen toggle
    const fullscreenButton = document.querySelector('[data-toggle-fullscreen]');
    if (fullscreenButton) {
        fullscreenButton.addEventListener('click', () => {
            if (!isFullscreen) {
                if (gameFrame.requestFullscreen) {
                    gameFrame.requestFullscreen();
                } else if (gameFrame.webkitRequestFullscreen) {
                    gameFrame.webkitRequestFullscreen();
                } else if (gameFrame.msRequestFullscreen) {
                    gameFrame.msRequestFullscreen();
                }
                fullscreenButton.querySelector('i').classList.remove('fa-expand');
                fullscreenButton.querySelector('i').classList.add('fa-compress');
                isFullscreen = true;
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
                fullscreenButton.querySelector('i').classList.remove('fa-compress');
                fullscreenButton.querySelector('i').classList.add('fa-expand');
                isFullscreen = false;
            }
        });
    }

    // Restart buttons
    const restartButtons = document.querySelectorAll('[data-game-restart]');
    restartButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (displayTimer) {
                clearInterval(displayTimer);
            }
            game.restart();
        });
    });

    // Back button
    const backButton = document.querySelector('[data-backward]');
    if (backButton) {
        backButton.addEventListener('click', () => {
            window.history.back();
        });
    }
}

export default { initGame };




// WEBPACK FOOTER //
// ./src/scripts/game-what-missing.js